// extracted by mini-css-extract-plugin
export default {"fullPage":"DetailsPageLoader_fullPage__NRpyo","icon":"DetailsPageLoader_icon__CtIfG"};